import React from 'react'
import ErrorImg from '../Assets/404.svg'
import TopNav from '../components/TopNav/TopNav'
import Header from '../components/Header/Header'
import ScrolltoTop from '../components/Scrolltotop/ScrolltoTop'
import Footer from '../components/Footer/Footer'
import SubFooter from '../components/SubFooter/SubFooter'
import "./ErrorPage.css"
import { useHistory } from 'react-router'

const ErrorPage = () => {
    const history = useHistory()
    return (
        <div className="ErrorPageWrapper">

            <div className="container contentContainer">
                <img src={ErrorImg} alt="error" style={{ margin: "1rem auto" }} />
                <div className="content">
                    <h2 className="title">Page Not Found</h2>
                    <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
                </div>
                <button onClick={() =>
                    // history.push("/")
                    window.location.href = process.env.RAZZLE_APP_BASE_URL
                }>GO BACK TO HOMEPAGE</button>
            </div>

        </div>
    )
}


export default ErrorPage
